<template>
  <div id="app-container">
    <SiteNavbar /> 
    
    <main>
      <router-view/>
    </main>

    <FloatingWhatsappButton />
    <SiteFooter /> 

    </div>
</template>

<script>
import SiteNavbar from '@/components/Navbar.vue';
import SiteFooter from '@/components/Footer.vue';
import FloatingWhatsappButton from '@/components/FloatingWhatsappButton.vue';

export default {
  name: 'App',
  components: {
    SiteNavbar,
    SiteFooter,
    FloatingWhatsappButton
  }
}
</script>

<style>
/* Global Styling */
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;700&display=swap');

:root {
  --primary-color: #0D47A1; /* Biru Tua Elegan */
  --secondary-color: #FFC107; /* Kuning Emas untuk Aksen */
  --dark-grey: #333333;
  --light-grey: #f4f4f4;
  --text-color: #2c3e50;
  --success-color: #2E7D32; /* Hijau untuk status "SOLD OUT" */
}

body {
  margin: 0;
  font-family: 'Poppins', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-color);
  background-color: #FFFFFF;
  padding-top: 75px;
}

#app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

main {
  flex-grow: 1;
}

h1, h2, h3, h4, h5, h6 {
  color: var(--dark-grey);
  font-weight: 700;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.cta-button {
  display: inline-block;
  background-color: var(--secondary-color);
  color: var(--dark-grey);
  padding: 12px 28px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 700;
  font-size: 16px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border: none;
  cursor: pointer;
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}
</style>